/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReasonForRequest
 */
export interface ReasonForRequest {
    /**
     * 
     * @type {string}
     * @memberof ReasonForRequest
     */
    reason: string;
}

/**
 * Check if a given object implements the ReasonForRequest interface.
 */
export function instanceOfReasonForRequest(value: object): value is ReasonForRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ReasonForRequestFromJSON(json: any): ReasonForRequest {
    return ReasonForRequestFromJSONTyped(json, false);
}

export function ReasonForRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReasonForRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function ReasonForRequestToJSON(value?: ReasonForRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

